<template>
  <div class="ws_common_modal">
    <div class="ws_common_modal_body">
      <div class="ws_common_modal_header">
        <h2>Exit "{{ this.groupInfo.name }}" Group?
        </h2>
      </div>
      <div class="ws_common_modal_btn text-center">
        <button class="btn remove_yes_no" @click="leaveGroupRoomMethod">Exit</button>
        <button class="btn remove_yes_btn ml-3" @click="leaveGroupRoomPopupClosed">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import { bus } from '@/main';

export default {
  name: 'UserLeaveGroupPopup',
  props: ['groupInfo'],
  mounted() {
    document.body.classList.add('body_right_scroll_remove');
  },
  methods: {
    getRoomListMethod(){
      this.$store.dispatch('getAllLeftChatListDetailsFun');
    },
    leaveGroupRoomMethod() {
      this.$store.dispatch('leaveRoomGroupByIdFun', {
        room_id: this.groupInfo.id
      }).then(() => {
        this.getRoomListMethod();
        this.leaveGroupRoomPopupClosed();
      })
    },
    leaveGroupRoomPopupClosed() {
      bus.$emit('leaveGroupPopupStateBus', false);
      document.body.classList.remove('body_right_scroll_remove');
    }
  }
}
</script>

<style lang="scss" scoped>
.ws_common_modal {
  position: fixed;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.92);
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  padding: 10px;
  align-items: center;

  .ws_common_modal_body {
    background: #000;
    width: 100%;
    margin: 0px auto;
    border-radius: 5px;
    padding: 20px 15px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    max-width: 580px;
    color: #ffffff;
    -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
  }

  .ws_common_modal_header h2 {
    font-size: 18px;
    color: #ffffff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    text-align: center;
    margin: 0 0 30px;
  }

  .btn {
    font-size: 16px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    padding: 10px 5px;
    min-width: 100px;
    line-height: 1;
    border-radius: 3px;
    outline: none !important;
    border: none !important;
    box-shadow: none !important;

    &:hover {
      background: #ffe738 !important;
      color: #22292f !important;
    }
  }

  .remove_yes_btn {
    background: rgba(255, 18, 18, 0.5);
    color: #fff;
  }

  .remove_yes_no {
    background: rgba(33, 228, 0, 0.5);
    color: #fff;
  }
}
</style>